//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from './mainViewMixin';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewNiotaClassicOriginators',
  mixins: [mainViewMixin],
  data: function data() {
    return {};
  },
  computed: {
    headerBG: function headerBG() {
      return './img/consumer.png';
    }
  },
  methods: {
    selectedType: function selectedType(type) {
      this.editedItem.type = type;
      this.editedItem = cloneDeep(this.editedItem);
    },
    resetType: function resetType() {
      delete this.editedItem.type;
      this.editedItem = cloneDeep(this.editedItem);
    }
  }
};